import React, { FC } from 'react';
import { useTranslation } from '@wix/wix-i18n-config';
import { EmptyState, TextButton } from '@wix/design-system';
import { Refresh, StatusAlert } from '@wix/wix-ui-icons-common';

type Props = {
  onTryAgain: () => void;
};

export const StoreSetupStepError: FC<Props> = ({ onTryAgain }) => {
  const { t } = useTranslation();

  return (
    <EmptyState
      skin="page"
      title={t('store-setup-step.error.title')}
      subtitle={t('store-setup-step.error.subtitle')}
      image={<StatusAlert />}
    >
      <TextButton onClick={onTryAgain} prefixIcon={<Refresh />}>
        {t('store-setup-step.error.button')}
      </TextButton>
    </EmptyState>
  );
};
